var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrigoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_16828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.112 0H8.88801C3.9793 0 0 3.9793 0 8.88801V27.112C0 32.0207 3.9793 36 8.88801 36H27.112C32.0207 36 36 32.0207 36 27.112V8.88801C36 3.9793 32.0207 0 27.112 0Z",
    fill: "#FFDD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.565 13.6892C24.9518 15.0082 25.3553 16.5654 25.8886 17.9199C26.4218 19.2744 27.092 20.6521 26.9853 22.1026C26.836 24.1291 25.19 25.752 23.391 26.6942C20.5131 28.1998 16.9525 28.4095 13.9751 27.1119C10.9976 25.8142 8.69736 22.9914 8.17297 19.7846C8.14631 19.6193 8.12497 19.4415 8.1943 19.2887C8.26363 19.1358 8.45916 19.0274 8.60493 19.1091C7.93833 18.4301 7.97743 17.2906 8.42006 16.4498C8.58537 16.137 8.8058 15.8419 9.10621 15.6535C9.81014 15.2144 10.7149 15.4615 11.5344 15.5966C13.6853 15.9486 15.87 15.3993 17.98 14.8553C18.0191 14.8447 18.06 14.834 18.1027 14.8233C18.8421 14.6225 19.2794 13.8599 19.0803 13.1204C18.9523 12.6422 18.8297 12.1587 18.8084 11.6752C18.7301 9.92604 20.1682 8.24442 21.9067 8.04889C23.6452 7.85335 25.4406 9.35898 25.7499 11.0815L25.565 13.691V13.6892Z",
    fill: "#F7F3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7347 11.1507C26.2218 11.5791 26.7959 11.9062 27.411 12.1106C27.5994 12.1728 27.8198 12.2475 27.8856 12.4359C27.962 12.6528 27.7807 12.8714 27.5959 13.0065C27.1568 13.3265 26.6146 13.4794 26.0725 13.5274C25.5303 13.5754 24.9863 13.522 24.446 13.4634C24.3446 13.4527 24.238 13.4385 24.1615 13.3709C24.0531 13.2749 24.0495 13.1078 24.0709 12.9639C24.1846 12.1319 24.7908 11.3836 25.7347 11.1489V11.1507Z",
    fill: "#FF7E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6572 24.6217C14.6031 24.3924 13.485 24.0582 12.8148 23.2139C12.6068 22.9508 12.4771 22.5135 12.7508 22.3233C12.5713 22.446 12.3277 22.35 12.1429 22.238C10.9572 21.5198 10.1893 20.16 10.1875 18.7734",
    stroke: "#E8DEDA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9797 11.8173C22.1643 11.8173 22.3139 11.6677 22.3139 11.4831C22.3139 11.2985 22.1643 11.1489 21.9797 11.1489C21.7951 11.1489 21.6455 11.2985 21.6455 11.4831C21.6455 11.6677 21.7951 11.8173 21.9797 11.8173Z",
    fill: "#514C4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_16828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrigoLogo);
export default __webpack_public_path__ + "static/media/frigoLogo.f5429e5557bcd978641a117e84d59a7d.svg";
export { ForwardRef as ReactComponent };